// 定义翻译项的类型
type TranslationItem = {
  'zh-CN': string;
  'en-US': string;
  [key: string]: string; // 添加索引签名，允许其他语言代码
};

// 定义整个翻译对象的类型
type TranslationsType = {
  [key: string]: TranslationItem;
};

// 在这里集中定义所有需要的翻译
export const translations : TranslationsType = {
  // 示例：定义您的自定义翻译
  'app.title': {
    'zh-CN': 'KDS 运营平台',
    'en-US': 'KDS Operation Platform'
  },
  'app.welcome': {
    'zh-CN': '欢迎使用',
    'en-US': 'Welcome'
  },
  // 添加更多您需要的翻译...
};